import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { dashboardLayoutComponent } from '../layouts/dashboard-layout-route';

const complaintSearchSchema = z.object({
  customer_report_status: z.string().optional(),
  user_id: z.string().optional(),
  start_at: z.string().optional(),
  end_at: z.string().optional(),
  sort_by: z.string().optional(),
  order: z.string().optional(),
  page: z.union([z.string(), z.number()]).optional(),
  limit: z.union([z.string(), z.number()]).optional(),
});

export const complaintRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/complaint',
  validateSearch: complaintSearchSchema,
  component: lazyRouteComponent(() => import('@/pages/complaint/complaint-page')),
});

export const createComplaintRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/complaint/create-complaint',
  component: lazyRouteComponent(() => import('@/pages/complaint/create')),
});

export const detailComplaintRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/complaint/$id',
  component: lazyRouteComponent(() => import('@/pages/complaint/detail')),
});
